import { colorSchemeNames } from 'ui/styling/baseVariables/colors/colorPalette'

const AVAILABLE_TAG_COLORS = colorSchemeNames.filter((c) => c !== 'Theme')

export function determineTagColor(tag: string) {
    const hash = tag.split('').reduce((acc, char) => {
        return acc + char.charCodeAt(0) + tag.length
    }, 0)

    return AVAILABLE_TAG_COLORS[hash % AVAILABLE_TAG_COLORS.length]
}
